import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    const skipRefresh = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"].some((p) =>
      url.includes(p)
    );
    if (error.response?.status === 401 && !original._retry && !skipRefresh) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch {
        // refresh fallito: la richiesta originale viene rigettata sotto
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Si è verificato un errore") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return e?.message || fallback;
}
